<app-card-lg [title]="'Issues'">
  <div *appLoading="(loading$ | async) || (machinesLoading$ | async)"></div>
  @if (!(loading$ | async) && !(machinesLoading$ | async)) {
    @for (issue of (issues$ | async); track issue) {
      <app-issues-list-item [issue]="issue" [machine]="getMachine(issue.machine_id)" [machineId]="machineId"></app-issues-list-item>
    }
  }
